/**
 * @features/dashboard/hooks/useDashboardNav.js
 * --------------------------------------------
 * Resolve the role-aware navigation list for the current user.
 *
 *   const items = useDashboardNav();          // for the active persona
 *   const items = useDashboardNav("dealer");  // explicit override
 *
 * Items missing the required permission are filtered out.
 * The hook is read-only — sidebar UI subscribes via React Context if it
 * needs reactivity to dynamic badges.
 *
 * v2.71.27 — Initial.
 */

import { useMemo } from "react";
import { useAuth } from "../../../lib/AuthContext";
import { resolvePersona, can } from "../config/permissions";
import { navForPersona } from "../config/navigationConfig";

export function useDashboardNav(forcedPersona) {
  const { user } = useAuth();
  return useMemo(() => {
    const persona = forcedPersona || resolvePersona(user);
    const items = navForPersona(persona);
    return items.filter((item) => !item.perm || can(user, item.perm));
  }, [user, forcedPersona]);
}
